import React from "react";
import Card from "components/card";
import { MapPin } from "lucide-react";
import Button from "components/button";
import { formatDateRange } from "utils";

const ProfileCard = ({ recordData }) => {
  return (
    <Card className="flex items-center gap-4 p-4 rounded-2xl border-2 bg-white hover:border-purple-200 hover:shadow-md transition-all duration-200">
      <span className="flex w-10 h-10 items-center justify-center rounded-full border-2 bg-slate-100 font-semibold text-sm">
        {recordData?.emp_initials}
      </span>
      <div className="flex-1">
        <p className="text-[14px] font-semibold">
          {recordData?.emp_name}
        </p>
        <p className="text-[12px] text-slate-700">
          {recordData?.emp_dept}
        </p>
        <div className="flex items-center gap-1.5 mt-0.5">
          <MapPin className="w-3 h-3 text-slate-700" />
          <span className="text-[11px] text-slate-700">
            {recordData?.country_name}
          </span>
        </div>
      </div>
      <div className="text-right">
        <p className="text-[13px] font-semibold text-purple-600 mb-2 tracking-normal">
          {formatDateRange(recordData?.emp_birthday)}
        </p>
        <Button
          className="inline-flex items-center justify-center whitespace-nowrap font-medium transition-all shrink-0 border rounded-lg gap-1.5 px-3 text-[11px] h-7 border-purple-200 text-purple-600 hover:bg-purple-50 hover:shadow-none"
        >
          Send Wishes
        </Button>
      </div>
    </Card>
  );
};

export default ProfileCard;

